/* eslint-disable import/prefer-default-export */
export const formatCentsToDollarString = (cents) => {
  const dollarAmount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  return cents >=0 ? `$${dollarAmount}` : dollarAmount.replace('-', '-$');
};



// WEBPACK FOOTER //
// ./app/javascript/app/utils/formatters/moneyDisplay.js